import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'app-upselling-buttons',
  templateUrl: './upselling-buttons.component.html',
  styleUrls: ['./upselling-buttons.component.css'],
})
export class UpsellingButtonsComponent implements OnInit {
  constructor(private router: Router) {}

  path = window.location.pathname.split('/')

  ngOnInit(): void {}

  goTo(path: string) {
    // Navigate to the specified path
    this.router.navigate(['home', 'get_devices', path]).then(() => {
      this.path = window.location.pathname.split('/')
    })

  }
}
